var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 12.6667C12.0003 13.1971 11.7896 13.7058 11.4145 14.0809C11.0395 14.456 10.5308 14.6667 10.0003 14.6667H5.33366C4.80323 14.6667 4.29452 14.456 3.91945 14.0809C3.54437 13.7058 3.33366 13.1971 3.33366 12.6667V4.66667H2.66699V2.66667H5.66699L6.33366 2H9.00033L9.66699 2.66667H12.667V4.66667H12.0003V12.6667ZM4.00033 4.66667V12.6667C4.00033 13.0203 4.1408 13.3594 4.39085 13.6095C4.6409 13.8595 4.98004 14 5.33366 14H10.0003C10.3539 14 10.6931 13.8595 10.9431 13.6095C11.1932 13.3594 11.3337 13.0203 11.3337 12.6667V4.66667H4.00033ZM12.0003 4V3.33333H9.33366L8.66699 2.66667H6.66699L6.00033 3.33333H3.33366V4H12.0003ZM5.33366 6H6.00033V12.6667H5.33366V6ZM9.33366 6H10.0003V12.6667H9.33366V6Z",
    fill: "#858699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d4cee43a37a87dfa5d7d888db7fe73fe.svg";
export { ForwardRef as ReactComponent };